import React, { useState, useEffect, useContext } from "react";
import Modalapprove from "./../management/modalapprove";
import { Link } from "react-router-dom";
import { datausers } from "../queue/datalist";
import { getMasterStatus, getdataapprove } from "./../../services/wms";
import BranchContext from "./../context/branch";
import moment from "moment";
const Allapprove = ({ handleonClikisopen, list }) => {
  const [isOpen, setisOpen] = useState(false);
  const [lista, setlista] = useState([]);
  const [status, setstatus] = useState([]);
  const [commentlist, setcommentlist] = useState([]);
  const { currentBranch } = useContext(BranchContext);
  const handleCancle = () => {
    setisOpen(false);
  };

  const handelClickmodalcomment = (event) => {
    const found = list.find((item) => item.id === event);
    if (found) {
      setcommentlist([found]);
      handleonClikisopen([found]);
    }
  };
  return (
    <div className="container-fluid p-1">
      {list &&
        list.length > 0 &&
        list.map((item, index) => (
          <div className="card1 shadow m-1 " key={index}>
            <div className="row m-1">
              <div className="col-xs-6 col-sm-4  col-lg-2 d-flex align-items-center">
                <span className="badge rounded-pill bg-primary  m-2">
                  {index+1}
                </span>
                <span className="badge rounded-pill bg-primary  me-2">
                  {item.name}
                </span>

                <div
                  className="text-primary"
                  style={{ fontSize: 16, fontWeight: "bold" }}
                >
                  {item.Cusnew}
                </div>
              </div>
              <div className="col-xs-6 col-sm-4  col-lg-2">
                <div>
                  <h6>
                    สาขา :
                    <small style={{ fontSize: 14 }}>
                      {" "}
                      {item.BranchName}
                    </small>{" "}
                  </h6>
                </div>
                <div>
                  <h6>
                    เลขที่ใบงาน :
                    <small style={{ fontSize: 14 }}> {item.Itemcode}</small>
                  </h6>
                </div>

                <div />
              </div>
              <div className="col-xs-6 col-sm-4  col-lg-2">
                <div>
                  <h6>
                    ประเภทลูกค้า :
                    <small style={{ fontSize: 14 }}>
                      {" "}
                      {item.CustomerTypeName}
                    </small>
                  </h6>
                </div>
                <div>
                  <h6>
                    ชื่อลูกค้า :
                    <small style={{ fontSize: 14 }}>
                      {" "}
                      {item.CustomerName}
                    </small>
                  </h6>
                </div>
              </div>
              <div className="col-xs-6 col-sm-4  col-lg-2">
                <div>
                  <div>
                    <h6>
                      วันที่บันทึก :
                      <small style={{ fontSize: 14 }}> {item.createdate}</small>
                    </h6>
                  </div>
                </div>
                <div>
                  <div>
                    <h6>
                      ผุ้ทำรายการ :
                      <small style={{ fontSize: 14 }}> {item.userrecord}</small>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-xs-6 col-sm-4  col-lg-1">
                <span>ข้อมูล</span>
                <div style={{ fontSize: "14px" }}>
                  {item.Data.length > 0 ? (
                    <span
                      className="badge bg-success"
                      style={{ fontSize: "14px", cursor: "pointer" }}
                      onClick={() => handelClickmodalcomment(item.id)}
                    >
                      {item.Data.length}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: "13px",
                        backgroundColor: item.hexcolor,
                      }}
                      className="badge badge text-dark"
                    >
                      {"กรุณาระบุสาเหตุ"}
                    </span>
                  )}
                  <span className="badge badge text-dark">
                    {" "}
                    {item.Data && item.Data.length > 0 && (
                      <span style={{ fontSize: "14px", cursor: "pointer" }}>
                        {item.Data[item.Data.length - 1].comment}
                      </span>
                    )}
                  </span>
                </div>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-2 col-lg-2">
                <div>
                  <div>
                    <h6>
                      วันที่อนุมัติ :
                      <small style={{ fontSize: 14 }}>
                        {" "}
                        {item.date_approve}
                      </small>
                    </h6>
                  </div>
                </div>
                <div>
                  <div>
                    <h6>
                      ผุ้อนุมัติ :
                      <small style={{ fontSize: 14 }}>
                        {" "}
                        {item.User_Approve}
                      </small>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-2 col-lg-1  d-flex align-items-center d-flex justify-content-end">
                <button
                  type="button"
                  className={"btn btn text-light  btn-sm bg-" + item.color}
                  style={{fontSize: "12px"}}
                >
                  {item.statusName}
                </button>

                <button
                  onClick={() => handelClickmodalcomment(item.id)}
                  type="button"
                  className="btn btn-primary btn-sm m-2"
                  style={{fontSize: "12px"}}
                >
                  View
                </button>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default Allapprove;
